import React, { useEffect, useRef, useState } from "react";
import { FilterWrapper } from "../../../assets/styles/FilterStyle.js";
import { TableWrapper } from "../../../Components/styledConstant.js";
import { AddNewCity, fetchCountryList, getCityList, getSuggestList, UpdateCityStatus } from "../../../utils/api.js";
import debounce from "lodash.debounce";
import AutoSuggestion from "../../../Components/AutoSuggest/AutoSuggest.js";
import { clickOutSide, isEmpty } from "../../../utils/common.js";
import Pagination from "../../../Components/Pagination/Pagination.jsx";
import { useNavigate, useRouteError } from "react-router-dom";
import { ModalPopUp } from "../../../Components/ModalPopUp/ModalPopUp.jsx";
import Input from "../../../Components/Input/Input.jsx";
import { AlertWrapper } from "../../../assets/styles/AlerWrapper.js";
import RichTextEditor from "../../../Components/RichTextEditor/RichText.js";
import { useDebounce } from "../../../Components/hooks/useDebounce.js";



const AddCity = () => {
    const [newCityData, setNewCityData] = useState({
         name:null,
         active:null,
         code:null,
         countryCode:null,
         feedSource:null,
         description:null
     });

       const navigate = useNavigate();
        const [errors, setErrors] = useState({});
        const [loading,setLoading] = useState(false);
        const [msg, setMsg] = useState(null);
        const [images, setImages] = useState([]);
        const [countryList, setCountryList] = useState([]);
               const [filteredCountries, setFilteredCountries] = useState([]);
               const [isOpen, setIsOpen] = useState(false);


         const outSideRefCountry = useRef(null)
             
              
              const debounceCountry = useDebounce(newCityData?.countryCode, 500);
             
               useEffect(() => {
                 fetchCountryList()
                   .then((response) => {
                     setCountryList(response?.data?.data?.countries || []);
                   })
                   .catch((error) => {
                     console.error("Failed to fetch country list:", error);
                   });
               }, []);
             
               useEffect(() => {
                 const filtered = countryList.filter((country) => (country?.name || "").toLowerCase().includes((debounceCountry || "").toLowerCase()));
                 setFilteredCountries(filtered || [])
               }, [debounceCountry, countryList]);
         
               const handleCountrySelect = (country) => {
                setNewCityData((prevData) => ({
                  ...prevData,
                  country: country.name,
                  countryCode: country.iso2,
                }));
                setIsOpen(false)
                setFilteredCountries([]);
              };
      
         

        const validateForm = () => {
            const newErrors = {};
             
            if (!newCityData.name || newCityData.name.trim() === "") {
              newErrors.cityName = "City Name is required.";
            }
            if (!newCityData.active) {
              newErrors.active = "Status is required.";
            }
            if (!newCityData.code || newCityData.code.trim() === "") {
              newErrors.code = "City Code is required.";
            }
            if (!newCityData.countryCode || newCityData.countryCode.trim() === "") {
              newErrors.countryCode = "Country Code is required.";
            }
            if (!newCityData.feedSource || newCityData.feedSource.trim() === "") {
              newErrors.feedSource = "Feed Source is required.";
            }
            if (images.length === 0) {
              newErrors.files = "At least one file is required.";
            } 
          
            setErrors(newErrors);
            return Object.keys(newErrors).length === 0; // Returns true if no errors
          };
          const handleModalInputChange = (e) => {
            const { name, value } = e.target;
            setNewCityData((prev) => ({
                ...prev,
                [name]: value,
            }));
        };
           const handleSubmit =()=>{
          
              if (!validateForm()) {
                return; 
              }
          
          
              const formData = new FormData();
              
              // Append each file to the FormData object under the "files" key
              images.forEach((image) => {
                formData.append("image", image.file); // Use the "files" key for multiple files
              });
          
              
              const request = {
                name:newCityData?.name,
                active:newCityData?.active === "true"?true:false,
                code:newCityData?.code,
                description:newCityData.description,
                countryCode:newCityData?.countryCode,
                feedSource:newCityData?.feedSource // Add any other relevant fields if needed
              };
            
              // Append the "request" object as JSON to FormData
              formData.append("request", JSON.stringify(request));
              
              AddNewCity(formData).then((resp)=>{
                if(resp){
                  if (resp.status === 200) {
                    setMsg({ type: "success", message: "City added successfully" });
                  } else {
                    setMsg({ type: "error", message: "Failed to add City. Please try again." });
                  }
                }
          
              })
          
              }
             
              const handleFileChange = (event) => {
                const files = Array.from(event.target.files);
                const newImages = files.map((file) => ({
                  id: Date.now() + Math.random(),
                  file,
                  url: URL.createObjectURL(file),
                }));
                setImages((prev) => [...prev, ...newImages]);
              
              };
              const handleDrop = (event) => {
                event.preventDefault();
                const files = Array.from(event.dataTransfer.files);
                const newImages = files.map((file) => ({
                  id: Date.now() + Math.random(),
                  file,
                  url: URL.createObjectURL(file),
                }));
                setImages((prev) => [...prev, ...newImages]);
              };
              const preventDefault = (e) => e.preventDefault();
   
              const handleDescriptionChange = (value) => {
                setNewCityData((prevData) => ({
                  ...prevData,
                  description: value, // Update description in viewHotelData
                }));
              }

               useEffect(()=>{
                        if(!outSideRefCountry) return
                        clickOutSide(outSideRefCountry,()=>setIsOpen(false));
                        return  clickOutSide(outSideRefCountry,()=>setIsOpen(false),"remove")
                      },[outSideRefCountry]);
             
   
    return(
    
       
    <div className="main_container">

        {!isEmpty(msg) && (
                      <AlertWrapper className={`${msg.type} globle`}>
                        <span className="close" onClick={() => setMsg({})}>
                          ×
                        </span>
                        {msg?.message}
                      </AlertWrapper>
                    )}
         <div className="userlist_head mb-5">
        <div className="userlist_heading">
              <div className="userlist_left">
                <label>Add New City</label>
              </div>
              </div>
              </div>
        <div className="subadmin_container justify-between flex column gap-20">
        <div style={{padding:"30px",flex:"1 1 100%"}}>
          
          <div className="flex gap-10" style={{flex:"1 1 100%"}}>

         <div style={{flex:"1 1 50%"}}>
               <div className="labelname mb-5">
                 <label className="fw-bold">City Name:</label>
               
               </div >
               <Input
                 type="text"
                
               placeholder="City Name"
                 name="name"
                 value={newCityData?.name}
                 onChange={handleModalInputChange}
            
                // click={checkStatus}
               />
               {errors.cityName && (
                 <p className="error fs-12 mt-10">{errors.cityName}</p>
               )}
             </div>

             <div className="input-field"  style={{flex:"1 1 50%"}}>
             <div className="labelname mb-5">
                 <label className="fw-bold">Status:</label>
               
               </div>
                   <select
                   style={{width:"100%", maxWidth:"330px"}}
                     className="input_select_field"
                     name="active"
                     value={newCityData?.active}
                     onChange={handleModalInputChange}
                   >
                     {/* <option value={""}>User Type</option> */}
                  
                     <option value="">Select Status</option> 
                    <>
                     <option value={"true"}>ACTIVE</option>
                    <option value={"false"}>INACTIVE</option>
                     </>
                   </select>
                   {errors.active && (
                 <p className="error fs-12 mt-10">{errors.active}</p>
               )}
                 </div>
         </div>

         <div className="flex gap-10 mt-20">
         <div  style={{flex:"1 1 50%"}}>
               <div className="labelname mb-5">
                 <label className="fw-bold">City Code:</label>
               
               </div>
               <Input
                 type="text"
              
                 placeholder="City Code"
                 name="code"
                 value={newCityData?.code}
                 onChange={handleModalInputChange}
                 
               />
               {errors.code && (
                 <p className="error fs-12 mt-10">{errors.code}</p>
               )}
             </div>

             <div  style={{flex:"1 1 50%",position:"relative"}} ref ={outSideRefCountry}>
                  <div className="labelname mb-5">
                    <label className="fw-bold">Country Code:</label>
                  </div>
                  <Input
                    type="text"
                   
                    placeholder="Country Code"
                    name="countryCode"
                    value={newCityData?.countryCode || ""}
                    onChange={handleModalInputChange}
                    onFocus={()=>setIsOpen(true)}
                  />
                    {filteredCountries.length > 0 && isOpen && (
                <div className="dropdown mt-10" style={{maxWidth:"330px",width:"100%",background:"#fff",position:"absolute"}}>
                  {filteredCountries.map((country) => (
                    <div
                      key={country.iso2}
                      className="dropdown-item fs-14"
                      style={{paddingBottom:"5px",borderBottom:"1px solid #8080803d",paddingTop:"5px",cursor:"pointer"}}
                      onClick={() => handleCountrySelect(country)}
                    >
                      {country.name} ({country.iso2})
                    </div>
                  ))}
                </div>
              )}
             
                </div>
        
        
        
        
         </div>

         <div className="flex gap-10 mt-20">
         <div  style={{flex:"1 1 50%"}}>
               <div className="labelname mb-5">
                 <label className="fw-bold">Feed Source:</label>
               
               </div>
               <Input
                 type="text"
                 maxLength={10}
                 placeholder="Feed Source"
                 name="feedSource"
                 value={newCityData?.feedSource}
                 onChange={handleModalInputChange}

              
               />
               {errors.feedSource && (
                 <p className="error fs-12 mt-10">{errors.feedSource}</p>
               )}
             </div>

            
            <div style={{flex:"1 1 50%"}}>
            <div className="labelname mb-5">
                 <label className="fw-bold">Upload File:</label>
               
               </div>
               <div
              style={{flex:"1 1 50%"}}
       className=""
       onDrop={handleDrop}
       onDragOver={preventDefault}
       onDragEnter={preventDefault}
       onDragLeave={preventDefault}
     >

       <input
         type="file"
         multiple
         accept=".jpg, .jpeg, .png, .webp, .avi"
         id="fileUpload"
         
         onChange={handleFileChange}
       />
      
             </div>
             {errors.files && <p className="error fs-12 mt-10">{errors.files}</p>}
         
            
            </div>

          
            
            
         
         
         </div>

         <div className="flex gap-10 mt-20">
              <div style={{flex:"1 1 50%"}}>
                 
                <RichTextEditor onContentChange={handleDescriptionChange} initialContent={newCityData?.description}></RichTextEditor>
                  
          
          
          </div> 
               
               </div>
     
       

        
          <div className="mt-50">
         <button onClick={handleSubmit} className="userlist_btn">Submit</button>
       </div>
        </div>
        
       
        
        </div>
       

        </div>
       

        

   )

}
export default AddCity;